var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#8593A3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M7 7.585a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#8593A3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M7 12.835c2.334-2.334 4.667-4.423 4.667-7a4.667 4.667 0 1 0-9.333 0c0 2.577 2.333 4.666 4.667 7"
})));
export { SvgLocationIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/LocationIcon.317fe0161b8dd7b8b2529617130f914b.svg";